var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9896 5.98141C10.2847 4.36808 7.5948 4.44227 5.98147 6.14713C4.36813 7.85199 4.44233 10.5419 6.14719 12.1553C7.85205 13.7686 10.542 13.6944 12.1553 11.9895C13.7686 10.2847 13.6945 7.59474 11.9896 5.98141ZM4.89197 5.11612C7.07471 2.80955 10.714 2.70916 13.0206 4.89191C15.1426 6.89994 15.3974 10.1407 13.7251 12.4425L17.5736 16.0843C17.8744 16.369 17.8875 16.8437 17.6028 17.1446C17.3181 17.4454 16.8434 17.4585 16.5426 17.1738L12.6941 13.532C10.488 15.3286 7.23813 15.2528 5.11618 13.2448C2.8096 11.062 2.70922 7.4227 4.89197 5.11612Z",
    fill: "#0F2342"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.b1b04a1dbebfb8a1b7da9df234642b96.svg";
export { ForwardRef as ReactComponent };